import gql from 'graphql-tag';

export default gql`
  query hydrationDefaultDailyGoal {
    me {
      id
      hydrationSettings {
        key
        defaultDailyGoal {
          value
          unit
        }
      }
    }
  }
`;
